import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { Transition as o, Dialog as c } from "@headlessui/react";
import { Fragment as i } from "react";
import { twMerge as a } from "tailwind-merge";
import { CloseIcon as F } from "../../icons/close-icon.mjs";
var C = /* @__PURE__ */ ((l) => (l.small = "small", l.medium = "medium", l.big = "big", l))(C || {});
function A({
  opened: l,
  onClose: n,
  children: d,
  title: u,
  size: m = "small",
  isFetching: t,
  afterLeave: p,
  afterEnter: f,
  className: y,
  contentClassName: g,
  isCentered: r,
  dialogClassName: x,
  backdropClassName: v,
  dialogContentClassName: h,
  dialogContentWrapperClassName: b,
  dialogContentWrapper1ClassName: w,
  titleClassName: N,
  closeIconWrapperClassName: j,
  closeIconClassName: T,
  ...k
}) {
  return /* @__PURE__ */ e(o.Root, { afterEnter: f, show: l, as: i, children: /* @__PURE__ */ s(
    c,
    {
      className: a("relative z-10", x),
      onClose: t ? () => {
      } : n,
      children: [
        /* @__PURE__ */ e(
          o.Child,
          {
            as: i,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ e(
              "div",
              {
                className: a(
                  "fixed inset-0 bg-[#000000]/20 transition-opacity",
                  v
                )
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: a("fixed inset-0 z-10 overflow-y-auto", b),
            children: /* @__PURE__ */ e(
              "div",
              {
                id: "modal-background",
                className: a(
                  "flex min-h-full w-full items-end justify-center text-center sm:items-center sm:p-0 lg:p-4",
                  w
                ),
                children: /* @__PURE__ */ e(
                  o.Child,
                  {
                    as: i,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    afterLeave: p,
                    children: /* @__PURE__ */ s(
                      c.Panel,
                      {
                        className: a(
                          "relative w-full",
                          m === "small" ? "max-w-2xl" : m === "medium" ? "max-w-4xl" : "max-w-7xl",
                          "bg-background-secondary transform rounded-lg text-left shadow-xl transition-all sm:my-8",
                          y
                        ),
                        ...k,
                        children: [
                          /* @__PURE__ */ s(
                            "div",
                            {
                              className: a(
                                "flex w-full items-start p-6 lg:p-10 lg:pb-0",
                                r ? "justify-center" : "justify-between",
                                h
                              ),
                              children: [
                                /* @__PURE__ */ e("h3", { className: a(r ? "px-6 lg:px-10" : "", N), children: u }),
                                /* @__PURE__ */ e(
                                  "button",
                                  {
                                    className: a(
                                      "focus-ring rounded-full",
                                      r && "absolute right-6 top-6 lg:right-10 lg:top-10",
                                      j
                                    ),
                                    disabled: t,
                                    onClick: n,
                                    children: /* @__PURE__ */ e(
                                      F,
                                      {
                                        className: a(
                                          "cursor-pointer",
                                          t && "fill-text-secondary pointer-events-none",
                                          T
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ e(
                            "div",
                            {
                              className: a(
                                "bg-background-secondary rounded-lg p-6 lg:p-10",
                                g
                              ),
                              children: d
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
export {
  C as ModalSizeEnum,
  A as default
};
